module.exports = __webpack_public_path__ + "img/AL271-2.356eb245.jpg";